import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import Dashboard from "../../components/SuperAdmin/Dashboard";

export default withRouter(connect()(Dashboard));
